
<template>
  <!--===== FOOTER =====-->

  <footer>
    <div class="footer_content">
      <div class="contact_info">
        <h2>{{content.footer_name}}</h2>
        <p>{{content.footer_email}}: dankao.chen@nxtech.pub</p>
        <p>{{content.footer_phone_no}}: +86 19883038871</p>
        <p>{{content.footer_address}}</p>
      </div>
      <div class="footer_images">
        <img src="../assets/img/Wechat_qrcode.png" alt="Wechat" class="footer_wechat">
        <img src="../assets/img/Bilibili_qrcode.jpg" alt="Bilibili" class="footer_bilibili">
      </div>
    </div>
    <div class="footer_bottom">
      <p>浙ICP备2023026746号-4</p>
      <p>© 2026 宁波云翰虹章信息科技有限公司. All rights reserved.</p>
    </div>
  </footer>


</template>

<script>
import { mapState} from 'vuex';
import en from '@/data/footer_en.js';
import cn from '@/data/footer_cn.js';
export default{
mixins: [en, cn],
  computed: {
    ...mapState(['language']),
    content() {
      const defaultContent = { title: '', industry_areas: [] };
      const currentLanguage = this.language === 'en' ? this.en : this.cn;
      return currentLanguage || defaultContent;
    }
  },
  watch: {
    language() {
      this.$forceUpdate();
    }
  }
}
</script>

